import { __assign, __rest } from "tslib";
import React from 'react';
import { useComponentRegistry } from '@bem-react/di';
import { cn } from '@bem-react/classname';
import './Modal.css';
export var cnModal = cn('Modal');
/**
 * Используется для создания всплывающих модальных окон.
 * @param {IModalProps} props
 */
export var Modal = function (_a) {
    var children = _a.children, className = _a.className, contentVerticalAlign = _a.contentVerticalAlign, _b = _a.hasAnimation, hasAnimation = _b === void 0 ? true : _b, targetRef = _a.targetRef, visible = _a.visible, props = __rest(_a, ["children", "className", "contentVerticalAlign", "hasAnimation", "targetRef", "visible"]);
    var Popup = useComponentRegistry(cnModal()).Popup;
    return (React.createElement(Popup, __assign({}, props, { className: cnModal({ visible: visible, hasAnimation: hasAnimation }, [className]), visible: visible }),
        React.createElement("div", { className: cnModal('Table') },
            React.createElement("div", { className: cnModal('Cell'), style: { verticalAlign: contentVerticalAlign } },
                React.createElement("div", { className: cnModal('Content'), ref: targetRef }, children)))));
};
Modal.displayName = cnModal();
